import { API_PREFIX_BLOCK_CONTENT_PATH } from "@/constants/prefix-path-api"
import { message } from "antd"
import { HttpClient } from "../../../../app/api/HttpClient"
import { FilterSearchParams } from "../../ui-builder/config/types"

export const fetchBlockContents = async (searchTerms: { [key: string]: string } = {}) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    pagination: { pageSize: "100" },
    filters: {
      isTemplate: { $eq: true },
    },
  }
  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value) {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  try {
    const response = await HttpClient.get<{ data: unknown[] }>(`${API_PREFIX_BLOCK_CONTENT_PATH}`, { params,skipDomainFilter:true })

    const modifiedResponse = response?.data.map((post: any) => ({
      ...post,
    }))

    return {
      data: modifiedResponse,
    }
  } catch (error) {
    message.error("Không thể lấy template. Vui lòng thử lại.")
  }
}

export const fetchTemplateId = async (id: number) => {
  const response = (await HttpClient.get(`${API_PREFIX_BLOCK_CONTENT_PATH}/${id}?populate=*`,{skipDomainFilter:true})) as { data: unknown }
  return response.data
}

export const deleteTemplate = async (id: number) => {
  return await HttpClient.delete(`${API_PREFIX_BLOCK_CONTENT_PATH}/${id}`,{skipDomainFilter:true})
}

export const addTemplates = async (data: any) => {
  return await HttpClient.post(`${API_PREFIX_BLOCK_CONTENT_PATH}`, data,{skipDomainFilter:true})
}

export const updateTemplate = async (id: number, data: any) => {
  return await HttpClient.put(`${API_PREFIX_BLOCK_CONTENT_PATH}/${id}`, data,{skipDomainFilter:true})
}
